import type { UiLocale } from "./i18n.ts";

export type AiAnswerLanguage =
  | "en"
  | "zh"
  | "zh-tw"
  | "ja"
  | "ko"
  | "es"
  | "fr"
  | "de"
  | "pt"
  | "it"
  | "ru";

export const AI_ANSWER_LANGUAGE_OPTIONS: AiAnswerLanguage[] = [
  "en",
  "zh",
  "zh-tw",
  "ja",
  "ko",
  "es",
  "fr",
  "de",
  "pt",
  "it",
  "ru",
];

export function defaultAnswerLanguage(locale: UiLocale): AiAnswerLanguage {
  if (locale === "zh" || locale === "ja" || locale === "ko") return locale;
  return "en";
}

export function normalizeAnswerLanguage(
  raw: string,
  fallback: AiAnswerLanguage,
): AiAnswerLanguage {
  const code = String(raw || "").trim().toLowerCase();
  return AI_ANSWER_LANGUAGE_OPTIONS.includes(code as AiAnswerLanguage)
    ? (code as AiAnswerLanguage)
    : fallback;
}

export function answerLanguageLabel(
  code: AiAnswerLanguage,
  t: (key: string) => string,
): string {
  return t(`projects.answerLanguage.${code}`);
}
